module.exports = __webpack_public_path__ + "img/22.1.896316a8.jpg";